import { useRef } from "react";
import classNames from "classnames";
import { LoadingText } from "../../../../../../common/LoadingText";
import { useAppDispatch } from "../../../../../../services/redux/hooks/use-dispatch";
import { useAppSelector } from "../../../../../../services/redux/hooks/use-selector";
import { AppButton } from "../../../../../../shared/components/AppButton";
import { AppTooltip } from "../../../../../../shared/components/AppTooltip";
import { AppUnderlinedTitle } from "../../../../../../shared/components/AppUnderlinedTitle";
import { getAiExamplesAction } from "../../../../redux/actions";
import {
  selectCaseEntityMode,
  selectCaseValid,
  selectExamplesLoading,
} from "../../../../redux/selectors";
import agent_harness_schema from "../../../../../../shared/assets/img/agent_harness_schema.png";
import { AiScoringSummary } from "./AiScoringSummary";
import { CaseExampleCallBlock } from "./CaseExampleCallBlock";
import { CaseExamplesBlock } from "./CaseExamplesBlock";
import styles from "./styles.module.css";
import { ImageViewModal } from "../../../../../../common/Components/Modals/components/ImageViewModal";
import { useAppModals } from "../../../../../../app/state/modalSlice/hook/use-app-modals";

interface Props {
  handleClickSolutionButton: () => void;
  className?: string;
}

export const CaseAiHelper = ({
  handleClickSolutionButton,
  className,
}: Props) => {
  const dispatch = useAppDispatch();
  const entityMode = useAppSelector(selectCaseEntityMode);
  const isExamplesLoading = useAppSelector(selectExamplesLoading);
  const caseSolutionValid = useAppSelector(selectCaseValid);
  const { handleCloseModal, handleOpenModal } = useAppModals();
  const ref = useRef<HTMLDivElement>(null);

  const handleGetCaseExamples = (query: string | null) => {
    dispatch(getAiExamplesAction(query));
  };

  return (
    <div className={classNames(styles["case-scoring"], className)}>
      <AppUnderlinedTitle leftContent={"ИИ Помощник"}>
        {entityMode === "case" && (
          <AppTooltip
            title={
              !caseSolutionValid &&
              "Заполните поля: Описание кейса, Артефакт на входе, Артефакт на выходе, Потребитель, Знания и Навыки"
            }
          >
            <div ref={ref}>
              <AppButton
                buttonType={"outlined"}
                onClick={handleClickSolutionButton}
                className={styles["generate-prompt-btn"]}
                disabled={!caseSolutionValid}
              >
                Сгенерировать начальный промпт
              </AppButton>
            </div>
          </AppTooltip>
        )}
      </AppUnderlinedTitle>
      <div className={styles["scoring-content"]}>
        {entityMode === "case" ? (
          <div className={styles["flex-container"]}>
            <AiScoringSummary />
            {/* <CaseExampleCallBlock
              handleGetCaseExamples={handleGetCaseExamples}
            />
            <CaseExamplesBlock />
            {isExamplesLoading && (
              <LoadingText text={"Идёт поиск по базе кейсов"} />
            )} */}
          </div>
        ) : (
          <div className={styles["agent-schema-container"]}>
            <img
              src={agent_harness_schema}
              className={styles["agent-schema-img"]}
              onClick={() => handleOpenModal("image_view_modal", null)}
            />
          </div>
        )}
      </div>
      <ImageViewModal
        src={agent_harness_schema}
        closeModal={handleCloseModal}
      />
    </div>
  );
};
